import styled from "styled-components";

export const StyledDeviceLink = styled.span`
    cursor: pointer;
    text-decoration: underline;
`;

export const SwitchContainer = styled.div`
    padding-bottom: 10px;
`;
